export { default as TempSelectedProduct } from './TempSelectedProduct';
